<template>
    <div>
        <div class="my-3 bg-white wow fadeInUp" style="margin-top:0px!important;">
            <div class="index_news_tit">
                <div class="news_type">最新文章</div>
                <div class="clear"></div>
            </div>
            <div class="index_news_list">
                <div class="index_news_photo" v-if="!isObjectEmpty(newtop)">
                    <div class="img">
                        <a :href="newtop.link" v-if="newtop.type==4" target="_blank">
                            <img :src="newtop.cover" :title="newtop.title">
                        </a>
                        <router-link :to="'/special/node_'+newtop.basic_id+'.html'" v-else-if="newtop.type==3" target="_blank">
                            <img :src="newtop.cover" :title="newtop.title">
                        </router-link>
                        <router-link :to="'/video/show-'+newtop.basic_id+'.html'" v-else-if="newtop.type==2" target="_blank">
                            <img :src="newtop.cover" :title="newtop.title">
                        </router-link>
                        <router-link :to="'/album/show-'+newtop.basic_id+'.html'" v-else-if="newtop.type==1" target="_blank">
                            <img :src="newtop.cover" :title="newtop.title">
                        </router-link>
                        <router-link :to="'/article/show-'+newtop.basic_id+'.html'" v-else target="_blank">
                            <img :src="newtop.cover" :title="newtop.title">
                        </router-link>
                    </div>
                    <div class="tit">
                        <a :href="newtop.link" v-if="newtop.type==4" target="_blank">
                            {{newtop.title}}
                        </a>
                        <router-link :to="'/special/node_'+newtop.basic_id+'.html'" v-else-if="newtop.type==3" target="_blank">
                            {{newtop.title}}
                        </router-link>
                        <router-link :to="'/video/show-'+newtop.basic_id+'.html'" v-else-if="newtop.type==2" target="_blank">
                            {{newtop.title}}
                        </router-link>
                        <router-link :to="'/album/show-'+newtop.basic_id+'.html'" v-else-if="newtop.type==1" target="_blank">
                            {{newtop.title}}
                        </router-link>
                        <router-link :to="'/article/show-'+newtop.basic_id+'.html'" v-else target="_blank">
                            {{newtop.title}}
                        </router-link>
                    </div>
                </div>
                <div class="news-a-no" v-for="(item,index) in newNews" :key="index">
                    <a :href="item.link" v-if="item.type==4" target="_blank">
                        
                        <div class="tit">{{item.title}}</div>
                    </a>
                    <router-link :to="'/special/node_'+item.basic_id+'.html'" v-else-if="item.type==3" target="_blank">
                        
                        <div class="tit">{{item.title}}</div>
                    </router-link>
                    <router-link :to="'/video/show-'+item.basic_id+'.html'" v-else-if="item.type==2" target="_blank">
                        
                        <div class="tit">{{item.title}}</div>
                    </router-link>
                    <router-link :to="'/album/show-'+item.basic_id+'.html'" v-else-if="item.type==1" target="_blank">
                        
                        <div class="tit">{{item.title}}</div>
                    </router-link>
                    <router-link :to="'/article/show-'+item.basic_id+'.html'" v-else target="_blank">
                        
                        <div class="tit">{{item.title}}</div>
                    </router-link>
                </div>
            </div>
        </div>
        <div class="my-3 bg-white wow fadeInUp">
            <div class="index_news_tit">
                <div class="news_type">热门文章</div>
                <div class="clear"></div>
            </div>
            <div class="index_news_list">
                <div class="index_news_photo" v-if="!isObjectEmpty(hottop)">
                    <div class="img">
                        <a :href="hottop.link" v-if="hottop.type==4" target="_blank">
                            <img :src="hottop.cover" :title="hottop.title">
                        </a>
                        <router-link :to="'/special/node_'+hottop.basic_id+'.html'" v-else-if="hottop.type==3" target="_blank">
                            <img :src="hottop.cover" :title="hottop.title">
                        </router-link>
                        <router-link :to="'/video/show-'+hottop.basic_id+'.html'" v-else-if="hottop.type==2" target="_blank">
                            <img :src="hottop.cover" :title="hottop.title">
                        </router-link>
                        <router-link :to="'/album/show-'+hottop.basic_id+'.html'" v-else-if="hottop.type==1" target="_blank">
                            <img :src="hottop.cover" :title="hottop.title">
                        </router-link>
                        <router-link :to="'/article/show-'+hottop.basic_id+'.html'" v-else target="_blank">
                            <img :src="hottop.cover" :title="hottop.title">
                        </router-link>
                    </div>
                    <div class="tit">
                        <a :href="hottop.link" v-if="hottop.type==4" target="_blank">
                            {{hottop.title}}
                        </a>
                        <router-link :to="'/special/node_'+hottop.basic_id+'.html'" v-else-if="hottop.type==3" target="_blank">
                            {{hottop.title}}
                        </router-link>
                        <router-link :to="'/video/show-'+hottop.basic_id+'.html'" v-else-if="hottop.type==2" target="_blank">
                            {{hottop.title}}
                        </router-link>
                        <router-link :to="'/album/show-'+hottop.basic_id+'.html'" v-else-if="hottop.type==1" target="_blank">
                            {{hottop.title}}
                        </router-link>
                        <router-link :to="'/article/show-'+hottop.basic_id+'.html'" v-else target="_blank">
                            {{hottop.title}}
                        </router-link>
                    </div>
                </div>
                <div class="news-a-no" v-for="(item,index) in hotNews" :key="index">
                    <a :href="item.link" v-if="item.type==4" target="_blank">
                        
                        <div class="tit">{{item.title}}</div>
                    </a>
                    <router-link :to="'/special/node_'+item.basic_id+'.html'" v-else-if="item.type==3" target="_blank">
                        
                        <div class="tit">{{item.title}}</div>
                    </router-link>
                    <router-link :to="'/video/show-'+item.basic_id+'.html'" v-else-if="item.type==2" target="_blank">
                        
                        <div class="tit">{{item.title}}</div>
                    </router-link>
                    <router-link :to="'/album/show-'+item.basic_id+'.html'" v-else-if="item.type==1" target="_blank">
                        
                        <div class="tit">{{item.title}}</div>
                    </router-link>
                    <router-link :to="'/article/show-'+item.basic_id+'.html'" v-else target="_blank">
                        
                        <div class="tit">{{item.title}}</div>
                    </router-link>
                </div>
            </div>
        </div>
      </div>
</template>
<script>
    import { post } from '../request'; 
    export default {
        name: 'RightPage',
        data() {
            return {
                hottop:{},
                newtop:{},
                hotNews:[],
                newNews:[],
            }
        },
        created() {
            this.getNewNews()
            this.getHot()
        },
        methods: {
            isObjectEmpty(obj) {  
                return JSON.stringify(obj) === '{}';  
            },  

            async getNewNews() {  
                try {  
                    const postData = {};  
                    const response = await post('latest', postData);  
                    if (response.data) {  
                        this.newNews = response.data;
                        const topNews = response.data.find(news => news.cover);   
                        if (topNews) {  
                            this.newtop = topNews;  
                        } else {  
                           this.newtop = {}; 
                        }                         
                    }  
               } catch (error) {  
                    console.error('最新新闻获取失败', error);  
                }  
            },  
            async getHot() {  
                try {  
                    const postData = {'day':7};  
                    const response = await post('hot', postData);  
                    this.hotNews = response.data;
                    const htopNews = response.data.find(news => news.cover);   
                        if (htopNews) {  
                            this.hottop = htopNews;  
                        } else {  
                            this.hottop = {}; 
                        }                         
                } catch (error) {  
                    console.error('热点新闻获取失败', error);  
                }  
            },  
        },
    }
</script>
  